import { render, staticRenderFns } from "./Form List.vue?vue&type=template&id=2a9b9740&scoped=true&"
import script from "./Form List.vue?vue&type=script&lang=js&"
export * from "./Form List.vue?vue&type=script&lang=js&"
import style0 from "./Form List.vue?vue&type=style&index=0&id=2a9b9740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b9740",
  null
  
)

export default component.exports